import script from "./CardDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDetail.vue?vue&type=script&setup=true&lang=js"

import "./CardDetail.vue?vue&type=style&index=0&id=1d752648&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d752648"]])

export default __exports__